<template>
  <Navbar :rightBtn="true"  :title="''"></Navbar>
  <div class="content content-bg" :class="{'content-match': source == 'match'}" @click="hideSearch">
    <img class="img" src="@/assets/images/bg/bg_7@2x.png" />
    <van-form class="form">
      <div class="title">确认企业信息</div>
      <div class="title-sub">匹配政策我们需要您的企业信息，请如实填写<br/>否则无法获取与您匹配的政策信息</div>
      <van-cell-group class="cell-group" outset>
        <div class="match-container-search">
          <van-field v-model="form.company_name" label="企业名称" placeholder="请输入企业名称" @input="formDebounce"
            @click-input.stop="handleInput">
          </van-field>
          <div class="detail" v-if="isFocus">
              <search-detail :searchList="searchList" :isSearch="isSearch" @toMatchDetail="toMatchDetail" :currentStr="currentSearchStr" @updateSearchStr="updateSearchStr" ref="searchDetails">
              </search-detail>
          </div>
        </div>
      </van-cell-group>
      <van-cell-group class="cell-group" inset>
        <van-field v-model="form.user_name" label="联 系 人" placeholder="请输入联系人姓名">
        </van-field>
      </van-cell-group>
      <van-cell-group class="cell-group" inset>
        <van-field v-model="form.phone" label="手机号码" name="phone" type="number" maxlength="11" placeholder="请输入手机号">
        </van-field>
      </van-cell-group>
      <van-cell-group class="cell-group flex" inset v-if="!showCode" style="border:0;">
        <!-- 通过 validator 进行函数校验 -->
        <div class="validator-box flex-item">
        <van-field v-model="form.code" name="validator" type="number" placeholder="请输入验证码">
        </van-field>
        </div>
        <div class="code-box flex-item">
          <van-button class="btn-code" size="small" type="primary" @click="getCode" :disabled="disabled">{{ codeText }}</van-button>
          </div>
      </van-cell-group>

      <!-- <coupon-group :show="userInfo.authentication_flag"></coupon-group> -->

      <div class="cell-group-btn">
        <van-button class="btn" round block type="primary" :disabled="!form.company_name || !form.phone || !form.user_name"
          @click.stop="submit">
          <span>{{source == 'addCompanyInfo'?'下一步':'提交'}}</span>
        </van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import { savePhoneAndCompanyName, queryUserById, getCode, getCompanyLists, companyCertificationV2 } from '@/api/home'
import Navbar from '@/components/Navbar.vue'
import { clickUrl, clickUrlToPhone } from '@/utils'
import SearchDetail from '@/components/SearchDetail.vue'
import CouponGroup from '../../components/CouponGroup.vue'

function debounce(func, wait = 1000) { //可以放入项目中的公共方法中进行调用
  let timeout;
  return function (event) {
    clearTimeout(timeout)
    timeout = setTimeout(() => {
      func.call(this, event)
    }, wait)
  }
}

export default {
  name: 'Purchase',
  components: { Navbar, SearchDetail, CouponGroup },
  data() {
    return {
      form: {
        company_name: '',
        phone: '',
        code: '',
        user_name: ''
      },
      userInfo: {},
      loading: false,
      codeText: '获取验证码',
      isFocus: false,
      isSearch: false,
      searchList: [],
      currentSearchStr: '',
      source: '',
      disabled: false
    }
  },
  computed:{
    showCode(){
      return ((this.userInfo.company && this.form.company_name == this.userInfo.company.name) &&
      (this.form.phone == this.userInfo.phone) &&
      (this.form.user_name == this.userInfo.name) 
      )
    }
  },
  mounted() {
    this.form.provider_id = this.$route.query.serviceProviderId
    this.form.declare_id = this.$route.query.declare_id
    this.source = this.$route.query.source ? this.$route.query.source : ''
    if (this.source != 'match') {
      this.getUserInfo()
    }
  },
  methods: {
    async getUserInfo() {
      console.log(33333)
      try {
        let res = await queryUserById()
        this.userInfo = res.result || {}
        this.form.company_name = res.result.company ? res.result.company.name : ''
        this.form.phone = res.result.phone ? res.result.phone : ''
        this.form.user_name = res.result.name ? res.result.name : ''
        this.search()
      } catch { }
    },
    formDebounce: debounce(function () {
      if(this.form.company_name.length>=3){
        this.search()
      }
    }, 1000),
    handleInput() {
      this.isFocus = true
    },
    hideSearch() {
      this.isFocus = false
    },
    async search() {
      this.isSearch = true
      this.currentSearchStr = this.form.company_name
      try{
      let res = await getCompanyLists({ keywords: this.form.company_name })
      this.searchList = res.result || []
      } catch{

      } finally{
        this.isSearch = false
      }
    },
    toMatchDetail(arg) {
      console.log(this, arg)
      this.form.company_name = arg.name
      this.isFocus = false
    },
    async updateSearchStr(arg) {
      this.form.company_name = arg
      await this.search()
      this.isFocus = true
    },
    async getCode() {
      if (this.form.phone == "") {
        this.$toast("手机号不得为空")
        return false
      }
      if (this.form.phone.length != 11 || !/1\d{10}/.test(this.form.phone)) {
            this.$toast({message: '手机号输入错误'})
            return false
      }
      if (this.disabled) {
          return false
      }
      this.disabled = true
      try {
        let res = await getCode({
          phone: this.form.phone
        })
        this.$toast.success({ message: '发送成功', duration: 2000 })
        let maxNum = 60
        let oldCodeText = this.codeText
        this.codeText = `${maxNum}s` //初始显示倒计时
        let codeCountDown = setInterval(() => {
          
          let countDownNum = maxNum--
          this.codeText = `${countDownNum}s`
          if (countDownNum == 0) {
            //倒计时结束
            this.codeText = '重新获取验证码'
            clearInterval(codeCountDown)
            this.disabled = false
          }
        }, 1000)
      } catch {
        this.disabled = false
      }
    },
    async submit() {
      var that = this
      sessionStorage.removeItem('matchList')
      sessionStorage.removeItem('declare_type2')
      sessionStorage.removeItem('declare_type1')
      sessionStorage.removeItem('info')
      sessionStorage.removeItem('time')
      if (this.loading) {
        return false
      }
      this.loading = true

      if(!this.checkForm()){
        this.loading = false
        return false
      }

      let { company_name, phone, code, declare_id, provider_id,user_name } = this.form
      let params = {
        company_name: company_name,
        phone: phone,
        code: code,
        declare_id: declare_id || '',
        provider_id: provider_id || '',
        user_name: user_name
      }
      console.log(params);
      try {
        let api = this.source ? companyCertificationV2(params) : savePhoneAndCompanyName(params)
        let res = await api
        this.orderInfo = res.result
        that.$toast.success({ message: '提交成功' })
        this.checkXcx()
      } catch {
        // that.$toast({ message: '提交失败' })
      } finally {
        this.loading = false
      }

    },
    checkXcx() {
      var u = navigator.userAgent
      if (u.indexOf('miniProgram') !== -1) {//在小程序里
        return false
      }
      if (this.source == 'match' || this.source == 'addCompanyInfo') {
        let searchStr = {
          name: this.form.company_name
        }
        clickUrl('/search/1', { search: JSON.stringify(searchStr), type: 2 })
        return false
      }
      if (this.source == 'certificateAgain') {
        clickUrl('/setup')
        return false
      }
      // 在微信网页
      this.$router.replace({ path: '/order/detail', query: { id: this.orderInfo } })
    },
    checkForm(){

      if(!this.form.company_name){
        this.$toast({message: '请输入企业名称'})
        return false
      }

      if (this.form.phone.length != 11 || !/1\d{10}/.test(this.form.phone)) {
        this.$toast({message: '手机号输入错误'});
        return false
      }

      if(!this.form.user_name){
        this.$toast({message: '请输入姓名'})
        return false
      }

      if (!this.showCode && !this.form.code) {
        this.$toast({message: '请填写短信验证码'});
        return false
      }
      return true
    },
  }
}
</script>
<style lang="scss" scoped>
.content-bg{
  img{
    height: auto;
    top: -132px;
    background-size: contain;
  }
}

.form {
  // margin-top: 4.2rem;
   margin-top: 55px;
  background: #fff;
  padding: 25px 32px;
  position: relative;
  z-index: 1;
  box-shadow: 0px -2px 12px 1px rgba(0, 0, 0, 0.1);
  border-radius: 20px;

  .title {
    font-size: 24px;
    font-weight: 500;
    color: #0E94E8;
    line-height: 28px;
    text-align: center;
    margin-bottom: 15px;
  }
}

.title-sub{
        font-size: 12px;
        color: rgba(0, 0, 0, 0.6);
        line-height: 24px;
        text-align: center;
        margin:20px 0 25px;
      }

.cell-group {
  margin: 7px 0;
  height: 40px;
  border-radius: 8px;
  border: 1px solid #D8DEE4;

  .van-cell {
    background: #fff;
  }
}

.cell-group-btn {
  margin: 35px 0 14px;
  font-size: 14px;

  .btn {
    width: 100%;
    height: 44px !important;
    margin: 0 auto;
  }
}
::v-deep .validator-box{
  background: #E2F5F2;
  border-radius: 8px;
  opacity: 1;
  text-align: center;
  box-sizing: border-box;
  .van-field{
    padding: 0;
    input.van-field__control{
      background: #E2F5F2;
        line-height:40px;
        text-align: center;
        border-radius: 8px;
        border: 1px solid #24CAA4;
        box-sizing: border-box;
        height: 38px;
    }
  }
}
.code-box{
    width: 101px;
    height: 40px;
    margin-left: 7px;
    .btn-code{
      width: 100%;
      height: 100% !important;
      background: #24CAA4;
      border-radius: 8px;
      color: #fff;
      border: 1px solid #24CAA4;
    }
  }

::v-deep .van-field__label{
  width: 1.8rem;
  color: #666;
  border-right: 1px solid #D8DEE4;
}
</style>
